export default "__VITE_ASSET__18e9642a__"